import type { FC } from 'react';
import { Table } from 'antd';
import type { ColumnsType } from 'antd/lib/table';

const getColumns = (): ColumnsType => [
  {
    title: 'ID',
    dataIndex: 'id',
  },
  {
    title: 'Inventories',
    dataIndex: 'name',
  },
  {
    title: 'ID of folder drive',
    dataIndex: 'folder_drive_id',
  },
  {
    title: 'Note',
    dataIndex: 'note',
  },
];

export const ExampleTable: FC = () => {
  const columns = getColumns();

  return (
    <Table
      columns={columns}
      pagination={{
        total: 100,
        pageSize: 10,
        current: 1,
        showSizeChanger: true,
      }}
    />
  );
};
